export default __webpack_public_path__ + "static/media/datePickerImage.ad5b4095.svg";